import type { ReactNode } from 'react';

export function Card({
  children,
  className = '',
  as: As = 'div',
}: {
  children: ReactNode;
  className?: string;
  as?: 'div' | 'section' | 'article';
}) {
  return (
    <As className={`card surface-enter ${className}`}>{children}</As>
  );
}
